import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import MaterialCheckbox from '../../material/MaterialCheckbox';
import i18n from '../../../src/i18n/translate';

export default class FormSaveButtons extends React.Component {
  static propTypes = {
    branded: PropTypes.bool,
    cancel: PropTypes.func,
    cancelButtonText: PropTypes.string,
    cancelIconType: PropTypes.string,
    className: PropTypes.string,
    buttonBaseClass: PropTypes.string,
    buttonStyle: PropTypes.string,
    buttonStyleSecondary: PropTypes.string,
    buttonStyleDelete: PropTypes.string,
    dataId: PropTypes.string,
    dataType: PropTypes.string,
    delete: PropTypes.func,
    deleteButtonText: PropTypes.string,
    deleteIconType: PropTypes.string,
    isDisabled: PropTypes.bool,
    leftButtonStyle: PropTypes.string,
    leftButtonText: PropTypes.string,
    leftButtonClick: PropTypes.func,
    leftButtonIconType: PropTypes.string,
    noPaddingButtons: PropTypes.bool,
    save: PropTypes.func,
    saveAndAdd: PropTypes.func,
    saveAndAddButtonText: PropTypes.string,
    saveAndAddCheckbox: PropTypes.bool,
    saveAndAddCheckboxClass: PropTypes.string,
    saveAndAddCheckboxText: PropTypes.string,
    saveAndAddIconType: PropTypes.string,
    saveButtonAreaClassName: PropTypes.string,
    saveButtonDisabled: PropTypes.bool,
    saveButtonText: PropTypes.string,
    saveButtonDataAction: PropTypes.string,
    saveIconType: PropTypes.string
  };

  static defaultProps = {
    branded: false,
    isDisabled: false,
    saveButtonDisabled: false,
    buttonBaseClass: 'btn',
    buttonStyle: 'primary',
    buttonStyleSecondary: 'secondary',
    buttonStyleDelete: 'primary',
    className: '',
    saveButtonAreaClassName: ''
  };

  constructor(props) {
    super(props);
  }

  buildCheckbox(show, btn_class, text, disabled) {
    if (show) {
      return (
        <MaterialCheckbox
          data-object-type={this.props.dataType}
          data-object-id={this.props.dataId}
          data-object-action={`form-save-add-another`}
          className={`${btn_class} left-checkbox`}
          disabled={disabled}
          inline={true}
          name="saveAndAddCheckbox"
        >
          {i18n.t(text)}
        </MaterialCheckbox>
      );
    }
  }

  buildButton(func, btn_id, btn_class, style, text, iconType, disabled, showLoader, dataAction) {
    if (showLoader) {
      style += ' btn-icon-text';
      iconType = 'spinner';
    }
    if (func) {
      return (
        <Button
          branded={this.props.branded}
          className={btn_class}
          data-action={dataAction}
          data-object-type={this.props.dataType}
          data-object-id={this.props.dataId}
          data-object-action={`form-${btn_id}`}
          disabled={this.props.isDisabled || disabled}
          icon={iconType}
          id={`${this.props.className}-${btn_id}`}
          label={i18n.t(text)}
          onClick={func}
          style={style}
        />
      );
    }
  }

  render() {
    const {
      buttonBaseClass,
      buttonStyle,
      buttonStyleDelete,
      buttonStyleSecondary,
      cancel,
      cancelButtonText,
      cancelIconType,
      className,
      deleteButtonText,
      deleteIconType,
      isDisabled,
      leftButtonStyle,
      leftButtonText,
      leftButtonClick,
      leftButtonIconType,
      noPaddingButtons,
      save,
      saveIconType,
      saveAndAdd,
      saveAndAddButtonText,
      saveAndAddCheckbox,
      saveAndAddCheckboxClass,
      saveAndAddCheckboxText,
      saveAndAddIconType,
      saveButtonAreaClassName,
      saveButtonDisabled,
      saveButtonText,
      saveButtonDataAction
    } = this.props;

    return (
      <div className={className}>
        <div className="col-3">
          {this.buildButton(leftButtonClick, 'left-button', buttonBaseClass, leftButtonStyle, leftButtonText, leftButtonIconType)}
          {this.buildButton(this.props.delete, 'delete', buttonBaseClass, buttonStyleDelete, deleteButtonText || i18n.t('Delete'), deleteIconType)}
        </div>
        <div className={`col-9 ${saveButtonAreaClassName} ${noPaddingButtons ? 'no-padding': ''}`}>
          {this.buildCheckbox(saveAndAddCheckbox, saveAndAddCheckboxClass, saveAndAddCheckboxText || i18n.t('Save and Add Another'))}
          {this.buildButton(cancel, 'cancel', buttonBaseClass, buttonStyleSecondary, cancelButtonText || i18n.t('Cancel'), cancelIconType)}
          {this.buildButton(save, 'save', buttonBaseClass, buttonStyle, saveButtonText || i18n.t('Save'), saveIconType, saveButtonDisabled, isDisabled, saveButtonDataAction)}
          {this.buildButton(saveAndAdd, 'save-and-add', buttonBaseClass, buttonStyle, saveAndAddButtonText || i18n.t('Save and Add Another'), saveAndAddIconType)}
        </div>
      </div>);
  }
}
